(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2544],{

/***/ 61528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/poshmark-posh-shows/index.tsx









function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-10-20",
      tag: "Poshmark",
      title: "Poshmark Posh Shows: Your New Avenue to Showcase Your Items",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Selling online is a proven method to generate income. And over the years, online shopping has prospered, giving way to the rise of more marketplaces and users across the globe. This allowed online sellers to earn extra without having to venture into a business with a physical store and staff to sustain daily operations. Hence, making it more convenient financially."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In today's world, millions of shoppers prefer buying items or services in the comfort of their own home. Often, they are using multiple sites not only to look for what they intend to buy but also to check what piques their interest. This is where great listings come in. A listing with attractive photos, an accurate title, a well-crafted description, and a price that fits their budget attracts potential buyers and significantly impacts sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While curating an attractive listing is one of the most critical parts of reselling, sellers should also actively find ways to broaden their audience reach and encourage shoppers to buy from their shop. Aside from aiming to gain followers and crosslist to multiple platforms, taking advantage of marketplace features is important."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One of the biggest marketplaces that actively develops new features for their users is Poshmark. This platform looks at its sellers as the heart and soul of their community. Hence, providing the tools and features that can help them sell more is one of the priorities aside from providing the best shopping experience to all its users."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you are selling on Poshmark, you should check how the new feature, Posh Shows, can be used to your advantage. Tap into a whole new level of selling. Read on and find out the ins and outs of the new feature and how you can make it part of your retail strategy."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Live Selling: What is it?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You have probably heard the term live selling as this is common on many social media platforms such as TikTok and Facebook or a social selling platform like Whatnot. But what's the deal with live selling that attracts buyers to it? Is it worth it?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Live selling or live streaming is an online shopping event that has revolutionized the e-commerce world. Before, sellers only depended on how their listings ranked in search results to be seen by potential buyers; live selling has changed it now. Considering the digitally inclined population we have, venturing into live e-commerce can affect your sales in a positive way as it can help you connect with your buyers both locally and internationally, making them purchase instantly."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Because the way many people shop now is influenced by convenience and the availability of technology, online entrepreneurs on digital communication platforms and marketplaces located in many countries have turned great profits through live selling."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Sell live with Poshmark Posh Shows"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Posh Shows are Poshmark's version of live selling. This new feature was launched on September 22, 2022, with the goal of bringing the posh community together into a live shopping event. This new feature can be a great channel to reel in more Poshers so you can showcase your items in real-time and get your closet discovered. All hosts can sell, auction, and promote items from their closet to help them encourage interaction with buyers, which is beneficial in increasing your chances of making sales and potentially, earning loyal customers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Hosting a Posh Show is easy and does not involve complicated steps. Once you have scheduled your Posh Show, you are only allowed to use one device. So, it can be through the app using your mobile phone, which you can switch the front or back camera for your convenience, or the website using your computer."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You also don't have to worry about time restrictions, as live selling on Poshmark does not have a time limit. This will let you interact with your potential buyers for as long as you like while upselling your featured listings. Furthermore, there are no extra fees for creating a Posh Show. It is similar to the marketplace fees that apply whenever you make a sale, and Poshmark's return policy still applies to all Posh Show purchases."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Currently, Posh Shows are in the beta testing period and only select sellers can join. However, Poshmark states that after they collect feedback and make some improvements, Posh Shows will be officially launched to all users soon."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Note:"
        }), " If you are an experienced live seller and are interested in being part of the beta test group and willing to provide feedback about live selling, you may fill out an application form", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://docs.google.com/forms/d/e/1FAIpQLSfGOLI-ooWoowsXTX3_1CoSZnxTbnUANkAh46r0zb25XWj_pw/viewform",
          children: "here"
        }), ". Keep an eye on your email, as Poshmark will notify you once you are eligible to be part of the beta group."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Posh Shows and Whatnot"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you are familiar with Whatnot, you might probably think that Posh Shows is similar to this social selling platform. Although they share the same concept, they differ in some ways. Below are some comparisons:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "About the Platform"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Poshmark is a marketplace where sellers can list items that buyers can buy anytime. On the other hand, Whatnot is an app built specifically to conduct live selling. It does not offer a channel for its sellers to list on the platform where buyers can place an order outside a live selling session."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Who Can Join"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "On Poshmark, anyone who has something to sell is eligible to sign up and list items. On the other hand, on Whatnot, only those with a history of selling, a good social following, and a lot of inventory are eligible to apply on their waitlist."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Eligibility to Go Live"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "While Poshmark Poshs Show are targeted to be available to all registered sellers once the beta stage is done, at Whatnot, you have to be approved first after applying to be able to host your live selling event."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "The confirmation of the application can take up to a week. Once approved, sellers are also required to sign-up for an onboarding session before being able to start live streaming."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Inclusion of Items"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "At Poshmark, including your listings on a Posh Show does not require a lot of effort. All you have to do is pick the listings from your closet that you want to feature in your live selling event. On the other hand, at Whatnot, you must upload all the items into a catalog so you can auction them into live streaming."
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to host a Posh Show"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Hosting a Posh Show gives you a chance to gain traction and increase your profits. To host one, you must create and schedule first, which you can book up to three months in advance. Here's how to do it:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your Account Tab (@username), or select your profile picture at the top-right of the page if you're on the website."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Click on ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "My Closet"
          }), ", then select the tools icon."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Choose ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "My Posh Shows"
          }), ", then ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Create"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Proceed to add your cover shot by selecting the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "camera icon"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Complete the necessary information, such as ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Title, Start Time, and Duration"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Add the listings from your closet that your viewers can buy during your show by selecting", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Add Listing"
          }), " (There is a limit of 50 listings per Posh Show)."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Once you have all the information and listings, select the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Schedule"
          }), " button."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Should you need to modify something in your scheduled Posh Show or cancel it, you can:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your Account Tab (@username), or select your profile picture at the top-right of the page if you're on the website."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Click on ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "My Closet"
          }), ", then select the tools icon."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Choose ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "My Posh Shows"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Select the Posh Show you want to update and click the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Update"
          }), " or ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Cancel"
          }), ' ', "option."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Posh Show Auctions: Where bidding happens"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Like any auction, interested buyers compete over one item by incrementing the amount of their bid on a set period. This is not different when you're hosting an Auction in your Posh Show. You can auction your listings, and shoppers can place their proposed amount, and whoever bids the highest will get the item."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When conducting an auction, you must decide whether you want to give your shoppers ample time to bid for your item. The auction duration can be 30, 45, or 60 seconds long. Also, keep in mind that your starting price cannot be lower than your listing price."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To start an auction:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Choose the listing from your Featured Listings that you want to put up for bidding while your Posh Show is happening."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Click the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Auction Item"
          }), " button."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Indicate your ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Starting Price"
          }), " and ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Auction Duration"
          }), "."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Note:"
        }), " Any reserved, sold, or Meet the Posher listings cannot be included in the auction. Also, don't forget to remind your buyers to set up their Shipping and payment details so they can join your auctions and submit a bid."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Keep your shop active with OneShop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We all know how time-consuming online selling is. You can quickly become overwhelmed with all the things you need to do to ensure you have a great listing. Not to mention all the tedious tasks like checking and refilling your inventory, packing orders, shipping, and managing your profits and finances. All of these can be draining if you are alone in your venture, but there is one trick of the trade that many sellers do - use automation."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While time and effort are always vital ingredients to a successful business, you don't have to do everything by yourself and stress over it. Managing your closet and other online shops won't tire you if you have a reliable automation service like OneShop. It can help you handle tedious tasks while you're busy tending to other parts of your business, like live selling."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop is an automation service favored by thousands of successful resellers. OneShop can help you automate sharing, liking, following, unfollowing, crosslisting, and relisting on your Poshmark account and help you crosslist and automatically delist on platforms like Mercari, Depop, and eBay."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "That's not all! OneShop wants to ensure that all its subscribers have a seamless selling experience; hence listing drafts is also made easier. Aside from having character counts to ensure you include enough details in your listing title and descriptions, OneShop also lets you take square photos right through the app and edit and store them should you need to use them again. OneShop will be with you at every step of your listing process."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In addition, if you are stressing over shipping your sold items from multiple platforms, checking your orders and printing your shipping labels are also made easier with OneShop. You don't have to go back and forth on different marketplaces to copy and paste the shipping information you need. With the app, you can print all your shipping labels from the sites OneShop supports, schedule USPS pick-ups, and order your shipping supplies."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop offers more than automation. Besides having My OneShop Sites, which is a personalized storefront for all your linked sites, you can also see your seller performance to track your progress, check your transaction record for bookkeeping and tax purposes, and many other features which will make online selling much easier and more enjoyable."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If these things sound good to you, sign up for OneShop's", ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "https://tools.oneshop.com/signup",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: constants/* Marketing.TrialDuration */.F1.TrialDuration
          }), "-day free trial"]
        }), ' ', "and see why thousands of resellers love this service. It only takes less than three minutes to set up your account to start enjoying all the features it offers."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-posh-shows.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Poshmark Posh Shows: Your New Avenue to Showcase Your Items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "What is a Posh Show? How can you host Posh Shows? Find out how you can connect with the Poshmark community through live selling with this new feature."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-posh-shows"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-posh-shows"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Poshmark Posh Shows: Your New Avenue to Showcase Your Items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "What is a Posh Show? How can you host Posh Shows? Find out how you can connect with the Poshmark community through live selling with this new feature."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-10-20T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-10-20T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 43510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-posh-shows",
      function () {
        return __webpack_require__(61528);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(43510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);